import type { ReactElement, ReactNode } from 'react';
import { EmptyState } from '@/design/EmptyState';
import { Panel } from '@/design/Panel';

/**
 * The screen for an address that does not exist.
 *
 * Everything else that used to live here now has a real screen of its own. The
 * sections that do not are blocked in App.tsx rather than given a placeholder.
 */

interface SectionProps {
  readonly title: string;
  readonly note: string;
  readonly headline: string;
  readonly detail: string;
  readonly action?: ReactNode;
}

function Section({ title, note, headline, detail, action }: SectionProps): ReactElement {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-display font-semibold">{title}</h1>
      <Panel title={title} note={note}>
        <EmptyState headline={headline} detail={detail} action={action} />
      </Panel>
    </div>
  );
}

export function NotFoundPage(): ReactElement {
  return (
    <Section
      title="Page not found"
      note="That address does not exist in the back office"
      headline="Nothing at this address"
      detail="The link may be out of date. Pick a section from the navigation to carry on."
    />
  );
}
